import { FormControl } from '@angular/forms';
import { OfferViewDTO } from './offer-view-dto.type';

export type MerchandiseControls = {
  id: FormControl;
  position: FormControl;
  newName: FormControl;
  forceQuotation: FormControl;
  offers: FormControl;
};

export class Merchandise {
  public id?: number;
  public position?: number;
  public newName?: string;
  public oldName?: string;
  public offers: OfferViewDTO[] = [];
  public forceQuotation: boolean = false;

  constructor(data: any = {}) {
    Object.assign(this, data);
    this.offers = (data.offers || []).map((offer: any) => new OfferViewDTO(offer));
  }

  public serialize() {
    return {
      id: this.id,
      position: this.position,
      newName: this.newName,
      oldName: this.oldName,
      offers: this.offers.map((offer: OfferViewDTO) => offer.serialize()),
      forceQuotation: this.forceQuotation,
    };
  }
}
